import antimicrobialUnitFragment from "./antimicrobialUnit";

const treatmentDefaultFragment = `
{
    treatment
    {   
        lastReviewed,
        titleDisplay,
        "complex": coalesce(complex, false), // TODO: In Sanity, make this false by default rather than giving a null value.
        dose,
        duration,
        food,
        frequency,
        administration,
        antimicrobialUnit->
          ${antimicrobialUnitFragment},
        
      }
}
`;

export default treatmentDefaultFragment;
